import { render, staticRenderFns } from "./activityWithdrawalPoint.vue?vue&type=template&id=85d84098&"
import script from "./activityWithdrawalPoint.vue?vue&type=script&lang=js&"
export * from "./activityWithdrawalPoint.vue?vue&type=script&lang=js&"
import style0 from "./activityWithdrawalPoint.vue?vue&type=style&index=0&lang=scss&scope=true&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports